// Announcements are now stored in Firestore and served via /api/announcements
// This file is kept for type reference only.

export interface Announcement {
  id: string;
  title: string;
  date: string;
  author: string;
  content: string;
  excerpt?: string;
}

export const announcements: Announcement[] = [];

export const getHomePageAnnouncements = (): Announcement[] => [];
export const getAllAnnouncements = (): Announcement[] => [];
